import React from 'react';
import { cn } from 'src/lib/utils';

/**
 * Brand-styled native radio input (TELV1-485).
 *
 * The dashboard has no Radix RadioGroup; every single-choice input is a native
 * <input type="radio">. Half of them were browser-default blue because each
 * call site had to remember the `accent-primary` incantation. This tiny
 * wrapper makes the brand-green radio the default everywhere.
 *
 * Deliberately NOT the shared text-field <Input>: its text-input classes
 * (h-10 w-full px-3.5 py-2.5, wrapper div) destabilise a 16px radio's
 * geometry and caused missed clicks in the export dialog (TELV1-484).
 */
const RadioOption = React.forwardRef<
  HTMLInputElement,
  Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>
>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    type="radio"
    className={cn('w-4 h-4 shrink-0 cursor-pointer accent-primary', className)}
    {...props}
  />
));

RadioOption.displayName = 'RadioOption';

export { RadioOption };
